const styles = theme => ({
  Navbar: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    minHeight: "64px",
    backgroundColor: theme.palette.background.paper,
    padding: "0 1rem",
    borderBottom: `1px solid ${theme.palette.divider || "rgba(0,0,0,0.1)"}`,
    flexWrap: "nowrap",
    gap: "0.5rem",
    transition: "background-color 0.3s ease",
    zIndex: 1000,
    "@media (max-width: 600px)": {
      minHeight: "56px",
      padding: "0.25rem 0.5rem",
      gap: "0.25rem",
      // Let the tool row wrap instead of overflowing on small screens.
      flexWrap: "wrap",
    }
  },
  logo: {
    marginRight: "15px",
    padding: "0 10px",
    fontSize: "18px",
    fontWeight: "700",
    letterSpacing: "0.5px",
    fontFamily: theme.typography.fontFamily,
    "& a": {
      textDecoration: "none",
      color: theme.palette.primary.main,
    },
    "@media (max-width: 600px)": {
      fontSize: "16px",
      padding: "0 5px",
      marginRight: "5px",
      display: props => (props.showSlider ? "none" : "block"),
    },
  },
  sliderContainer: {
    display: "flex",
    alignItems: "center",
    flex: 1,
    maxWidth: "340px",
    "@media (max-width: 768px)": {
      maxWidth: "200px",
    },
    // Keep the level slider reachable on mobile: drop it onto its own full
    // width row (it used to be hidden, leaving no way to change the level).
    "@media (max-width: 600px)": {
      order: 10,
      flex: "1 1 100%",
      maxWidth: "none",
      marginTop: "0.25rem",
    }
  },
  levelLabel: {
    color: theme.palette.text.secondary,
    fontSize: "0.85rem",
    marginRight: "10px",
    whiteSpace: "nowrap",
  },
  slider: {
    width: "100%",
    "& .rc-slider-track": {
      backgroundColor: theme.palette.primary.main,
    },
    "& .rc-slider-rail": {
      height: "4px",
      backgroundColor: theme.palette.type === 'dark' ? "#333" : "#ddd",
    },
    "& .rc-slider-handle": {
      backgroundColor: theme.palette.primary.main,
      border: "none",
      width: "14px",
      height: "14px",
      marginTop: "-5px",
      boxShadow: "none !important",
    },
  },
  selectContainer: {
    marginLeft: "auto",
    "& .MuiSelect-select": {
      color: theme.palette.text.primary,
      fontSize: "0.85rem",
      padding: "0.5rem 2rem 0.5rem 1rem",
    },
    "@media (max-width: 600px)": {
      "& .MuiSelect-select": {
        padding: "0.4rem 1.5rem 0.4rem 0.5rem",
      }
    }
  },
  iconButton: {
    color: theme.palette.text.secondary,
    padding: "8px",
    "&:hover": {
      color: theme.palette.primary.main,
    },
    "@media (max-width: 600px)": {
      padding: "6px",
      // Ensure icons are visible on white backgrounds
      color: theme.palette.type === 'light' ? 'rgba(0, 0, 0, 0.7)' : theme.palette.text.secondary,
    }
  },
  backButton: {
    color: theme.palette.text.primary,
    padding: "8px",
    marginRight: "0.5rem",
    "@media (max-width: 600px)": {
      padding: "6px",
      marginRight: "0.25rem",
    }
  },
  menuButton: {
    color: theme.palette.text.primary,
    padding: "8px",
    marginRight: "8px",
    // Visible only on mobile/tablet
    [theme.breakpoints.up("md")]: {
      display: "none",
    },
    "@media (max-width: 600px)": {
      padding: "6px",
      marginRight: "4px",
    }
  },
  breadcrumb: {
    display: "flex",
    alignItems: "center",
    marginLeft: "0.5rem",
    color: theme.palette.text.secondary,
    fontSize: "0.85rem",
    "@media (max-width: 900px)": {
      display: "none",
    },
  },
  breadcrumbSeparator: {
    margin: "0 0.5rem",
    opacity: 0.5,
  },
  breadcrumbText: {
    color: theme.palette.text.primary,
    fontWeight: 500,
  },
  drawerPaper: {
    width: "280px",
    backgroundColor: theme.palette.background.paper,
    color: theme.palette.text.primary,
  },
  drawerContent: {
    width: "100%",
    height: "100%",
    display: "flex",
    flexDirection: "column",
  },
  drawerHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "1rem 1.5rem",
    backgroundColor: theme.palette.type === 'dark' ? "rgba(255,255,255,0.05)" : "rgba(0,0,0,0.02)",
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
  drawerTitle: {
    margin: 0,
    fontSize: "1.2rem",
    fontWeight: 700,
    color: theme.palette.primary.main,
    fontFamily: theme.typography.fontFamily,
  },
  drawerCloseButton: {
    color: theme.palette.text.secondary,
  },
  drawerActiveItem: {
    backgroundColor: theme.palette.type === 'dark' ? "rgba(100, 181, 246, 0.12)" : "rgba(100, 181, 246, 0.08)",
    borderLeft: `4px solid ${theme.palette.primary.main}`,
  }
});
export default styles;
